import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class ProjectServiceService {

  private selectedView: any;
  private selectedContentType: any;
  private selectedOrganization: any;
  public from: number;
  public size: number;
  public currentPage: number;
  public page: string;

  constructor() { }
  setSelectedView(view) {
    this.selectedView = view;
  }
  getSelectedView() {
    return this.selectedView;
  }
  setSelectedContentType(contentType) {
    this.selectedContentType = contentType;
  }
  getSelectedContentType(page) {
    if (this.page === page) {
      return this.selectedContentType;
    }
  }
  setPageValues(from: number, size: number, currentPage: number) {
    this.from = from;
    this.currentPage = currentPage;
    this.size = size;
  }
  setOrganization(organization) {
    this.selectedOrganization = organization;
  }
  getOrganization(page) {
    if (this.page === page) {
      return this.selectedOrganization;
    }
  }

}
